import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	freeAccount: {
		id: 'partner.welcome.freeAccount',
		defaultMessage: "To begin, you'll need to log in or create a personal Calm account.",
		description: 'Activation text',
	},
	logIn: {
		id: 'partner.welcome.logIn',
		defaultMessage: 'Log in',
		description: 'Text prompting the user to sign into their existing Calm account',
	},
	signUpFree: {
		id: 'partner.welcome.signUpFree',
		defaultMessage: 'Sign up for free',
		description: 'Text prompting the user to sign up for a free Calm account',
	},
	haveAccount: {
		id: 'partner.welcome.haveAccount',
		defaultMessage: 'Do you have a Calm account?',
		description: 'Have Account text',
	},
	month: {
		id: 'partner.welcome.offerDuration.month2',
		defaultMessage: 'first {quantity, plural, one {month} other {{quantity} months}}',
		description: 'Text indicating the one month duration for the offer',
	},
	year: {
		id: 'partner.welcome.offerDuration.year2',
		defaultMessage: 'first {quantity, plural, one {year} other {{quantity} years}}',
		description: 'Text indicating the year duration for the offer',
	},
	dtcPartnershipCalmTerms: {
		id: 'partner.dtc.calmterms',
		defaultMessage: "Offer not available if you've previously used a Calm Premium free trial.",
		description:
			"Text informing the user they'd only be eligible to claim if they have not tried or trialed with Calm",
	},
	dtcPartnershipTermsAndConditions: {
		id: 'partner.dtc.termsAndConditionsLabel',
		defaultMessage: 'Terms & Conditions Apply',
		description: 'Text informaing the user that more terms and conditions apply',
	},
	dtcPartnershipOfferValidThrough: {
		id: 'partner.dtc.dtcPartnershipOfferValidThrough',
		defaultMessage: 'Offer valid through {date}.',
		description: 'Text informaing the user that more terms and conditions apply',
	},
	dtcPartnershipAutoRenewYearly: {
		id: 'partner.dtc.dtcPartnershipAutoRenewYearly',
		defaultMessage:
			'When your offer ends you will automatically renew at {originalPrice} every year until canceled.',
		description: 'Text informaing the user that more terms and conditions apply',
	},
	dtcPartnershipAutoRenewMonthly: {
		id: 'partner.dtc.dtcPartnershipAutoRenewMonthly',
		defaultMessage:
			'When your offer ends you will automatically renew at {originalPrice} every month until canceled.',
		description: 'Text informaing the user that more terms and conditions apply',
	},
	dtcPartnershipRedemptionLimit: {
		id: 'partner.dtc.dtcPartnershipRedemptionLimit',
		defaultMessage: 'One redemption per offer per account.',
		description: 'Text informaing the user that more terms and conditions apply',
	},
});
